"use client";

import { useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import Cookies from "js-cookie";

import config from "@/lib/config";
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff } from "lucide-react";


interface StrapiError {
    data: null;
    error: {
        status: number;
        name: string;
        message: string;
        details: Record<string, unknown>;
    };
}

interface StrapiSuccess {
    jwt: string;
    user: {
        id: number;
        documentId: number;
        username: string;
        email: string;
        provider: string;
        confirmed: boolean;
        blocked: boolean;
        // Add other user properties as needed
    };
}

const SignupPage = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const router = useRouter();
    const searchParams = useSearchParams();
    const redirect = searchParams.get("redirect") || "/";

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        // setIsLoading(true); // Add loading state if needed

        try {
            const res = await fetch(`${config.baseUrl}/api/auth/local`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    identifier: username,
                    password: password,
                }),
            });

            const data: StrapiSuccess | StrapiError = await res.json();
            // console.log("data ==>", data);

            // Check if the response is an error
            if ("error" in data) {
                setError(data.error.message);
                setLoading(false);
                // setIsLoading(false);
                return;
            }

            // If we reach here, we have a successful response
            if (data.jwt) {
                setLoading(false);

                Cookies.set("lazulite_token", data.jwt);
                Cookies.set("lazulite_user_data", JSON.stringify(data));

                // You might want to store user data in context or state
                // setUser(data.user);
                // const getUserPath = GetUserActivePath()
                // console.log("getUserPath ===>", getUserPath);
                

                // Redirect to dashboard or home page
                router.push(`/redirect?redirect=${redirect}`);
            }
        } catch {
            setError("Network error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="flex items-center justify-center py-12">
            <div className="mx-auto grid w-[350px] gap-6">
                <div className="grid gap-2 text-center">
                    <h1 className="text-3xl font-bold">Login</h1>
                    <p className="text-balance text-muted-foreground">
                        Enter your username below to login to your account
                    </p>
                </div>
                <form onSubmit={handleSubmit} className="grid gap-4">
                    <div className="grid gap-2">
                        <Label htmlFor="username">Username</Label>
                        <Input
                            id="username"
                            type="text"
                            placeholder=""
                            required
                            autoComplete="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="grid gap-2">
                        <div className="flex items-center">
                            <Label htmlFor="password">Password</Label>
                            {/* <Link
                                    href="/auth/forgot-password"
                                    className="ml-auto inline-block text-sm underline"
                                >
                                    Forgot your password?
                                </Link> */}
                        </div>
                        <div className="relative">
                            <Input
                                id="password"
                                type={showPassword ? "text" : "password"}
                                required
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button
                                type="button"
                                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? (
                                    <EyeOff className="h-4 w-4 text-gray-500" />
                                ) : (
                                    <Eye className="h-4 w-4 text-gray-500" />
                                )}
                            </button>
                        </div>
                    </div>
                    {error && <p className="text-sm text-red-500">{error}</p>}
                    <Button disabled={loading} type="submit" className="w-full">
                        {loading ? "Loading..." : "Login"}
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default SignupPage;
